import {authAxios} from "../api/axiosClient";
import Cookies from 'universal-cookie';
import {listLamTuDongURL, listLamViecURL} from "../constants";
const cookies = new Cookies();

export const LichLamViecApi = (params={})=>{
        const url = listLamViecURL;
        return authAxios().get(url,{params});
}

export const TaoLichLamViecApi = (params={})=>{
        const url = listLamViecURL;
        return authAxios().post(url,params);
}

export const DeleteItemLichLamViecApi = (params={})=>{
        const url = listLamViecURL;
        return authAxios().delete(url,{data:params});
}

export const EditItemLichLamViecApi = (params={})=>{
        const url = listLamViecURL;
        return authAxios().put(url,params);
}

export const DelTaoLichTuDongcApi = (params={})=>{
        const url = listLamTuDongURL;
        return authAxios().put(url,params);
}

